import { render, staticRenderFns } from "./update-paypassword.vue?vue&type=template&id=6570eee2&scoped=true"
import script from "./update-paypassword.vue?vue&type=script&lang=js"
export * from "./update-paypassword.vue?vue&type=script&lang=js"
import style0 from "./update-paypassword.vue?vue&type=style&index=0&id=6570eee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570eee2",
  null
  
)

export default component.exports